import config from '../config';

// Helper to get the app base path for redirects
const getAppPath = (path) => {
  const hostname = window.location.hostname;
  const basename = (hostname === 'mycastle.gg' || hostname === 'www.mycastle.gg') ? '/app' : '';
  return `${basename}${path}`;
};

class AdminAPI {
  static async getHeaders() {
    const token = localStorage.getItem('admin_access_token');
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  static async refreshToken() {
    const refreshToken = localStorage.getItem('admin_refresh_token');
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    const response = await fetch(`${config.API_URL}/api/admin/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${refreshToken}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to refresh token');
    }

    const data = await response.json();
    localStorage.setItem('admin_access_token', data.access_token);
    return data.access_token;
  }

  static async makeRequest(url, options = {}) {
    let headers = await this.getHeaders();
    
    const requestOptions = {
      ...options,
      headers: {
        ...headers,
        ...options.headers
      }
    };

    let response = await fetch(url, requestOptions);

    // If token expired, try to refresh
    if (response.status === 401) {
      try {
        await this.refreshToken();
        headers = await this.getHeaders();
        requestOptions.headers = {
          ...headers,
          ...options.headers
        };
        response = await fetch(url, requestOptions);
      } catch (refreshError) {
        // Refresh failed, redirect to login
        this.redirectToLogin();
        throw new Error('Authentication failed');
      }
    }

    // If still unauthorized after refresh, redirect to login
    if (response.status === 401 || response.status === 403) {
      this.redirectToLogin();
      throw new Error('Not authorized');
    }

    return response;
  }

  static redirectToLogin() {
    localStorage.removeItem('admin_access_token');
    localStorage.removeItem('admin_refresh_token');
    localStorage.removeItem('adminEmail');
    localStorage.removeItem('adminName');
    localStorage.removeItem('isAdmin');
    window.location.href = getAppPath('/manage/login');
  }

  // Convenience methods
  static async get(endpoint) {
    const response = await this.makeRequest(`${config.API_URL}${endpoint}`);
    return response.json();
  }

  static async post(endpoint, data) {
    const response = await this.makeRequest(`${config.API_URL}${endpoint}`, {
      method: 'POST',
      body: JSON.stringify(data)
    });
    return response.json();
  }

  static async put(endpoint, data) {
    const response = await this.makeRequest(`${config.API_URL}${endpoint}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
    return response.json();
  }

  static async delete(endpoint) {
    const response = await this.makeRequest(`${config.API_URL}${endpoint}`, {
      method: 'DELETE'
    });
    return response.json();
  }
}

export default AdminAPI;